export const ZendeskLogo = ({ className = '' }) => {
  return (
    <svg
      className={className}
      width="35"
      height="35"
      viewBox="0 0 35 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="34" height="34" rx="3.5" stroke="#05050D" strokeOpacity="0.05" />
      <path
        d="M16.8552 14.4322V23.9996H9.02197L16.8552 14.4322ZM16.8552 11C16.8552 13.1865 15.1043 14.9576 12.9428 14.9576C10.7813 14.9576 9.02197 13.1865 9.02197 11H16.8552ZM18.1455 24C18.1455 21.8135 19.8964 20.0424 22.0579 20.0424C24.2194 20.0424 25.9703 21.8135 25.9703 24H18.1455ZM18.1455 20.5678V11H25.9785L18.1455 20.5678Z"
        fill="#05050D"
      />
    </svg>
  );
};
